<template>
<svg fill="none" viewBox="0 0 81 72">
    <path fill="#662D91" d="M12.988 60H41V12H12.988C10.794 12 9 13.815 9 16.034v39.932C9 58.185 10.794 60 12.988 60z"/>
    <path fill="#713E98" d="M41 60h28.013C71.206 60 73 58.185 73 55.966V16.034C73 13.815 71.206 12 69.013 12H41v48zM41 37.916V12H12.987c-3.788 0-5.383 4.84-2.492 7.16L41 37.916z"/>
    <path fill="#B17FD7" d="M69.013 12H41v25.916L71.505 19.16C74.395 16.84 72.8 12 69.013 12z"/>
</svg>
</template>

<script>
export default {
    name: 'KoneksiEmailIcon'
};
</script>